<div class="container">
  <div class="header">
    <div class="filters flex">
      <div class="availability-zone-filter filter">
        <label>Select Zones: </label>
        <icn-dropdown
          [allowMultiple]="true"
          [position]="'bottom'"
          [showSelection]="false"
          [selectedValues]="vm.selectedAvailabilityZoneIds"
          (selectedValuesChange)="vm.onAvailabilityZoneChanged()"
        >
          <icn-dropdown-item
            *ngFor="let availabilityZone of vm.allAvailabilityZones"
            [value]="availabilityZone.id"
            [title]="availabilityZone.displayName"
            [textColor]="availabilityZone.colorHex"
          >
          </icn-dropdown-item>
        </icn-dropdown>
      </div>
      <div class="channels-filter filter">
        <label>Select Channels: </label>
        <icn-dropdown
          class="select-channels-filter"
          [allowMultiple]="true"
          [position]="'bottom'"
          [selectedValues]="vm.selectedChannelIds"
          [showSelection]="false"
          (selectedValuesChange)="vm.onChannelFilterChanged()"
        >
          <icn-dropdown-item
            *ngFor="let channel of vm.visibleChannels"
            [value]="channel.id"
            [title]="channel.name"
            [multiple]="true"
          >
          </icn-dropdown-item>
        </icn-dropdown>
      </div>
      <div class="channels-filter filter">
        <label>Select Types: </label>
        <icn-dropdown
          [allowMultiple]="true"
          [position]="'bottom'"
          [showSelection]="false"
          [selectedValues]="vm.selectedTargetTypes"
          (selectedValuesChange)="vm.onTargetsFilterChanged()"
        >
          <icn-dropdown-item
            [title]="'MPEGTS'"
            [value]="'MPEGTS'"
          ></icn-dropdown-item>
          <icn-dropdown-item
            [title]="'SRT PULL'"
            [value]="'SRT PULL'"
          ></icn-dropdown-item>
          <icn-dropdown-item
            [title]="'SRT PUSH'"
            [value]="'SRT PUSH'"
          ></icn-dropdown-item>
          <icn-dropdown-item
            [title]="'HLS'"
            [value]="'HLS'"
          ></icn-dropdown-item>
          <icn-dropdown-item
            [title]="'FLV'"
            [value]="'FLV'"
          ></icn-dropdown-item>
        </icn-dropdown>
      </div>
    </div>
  </div>
  <div class="body">
    <div class="buttons">
      <ichannel-button
        [theme]="'DARK'"
        [callback]="vm.refreshButtonClicked.bind(vm)"
        [label]="'Refresh'"
      ></ichannel-button>
    </div>
    <table class="inputs-table">
      <thead>
        <tr>
          <th>Status</th>
          <th>Availability Zone</th>
          <th class="sort-column" (click)="vm.sortTargetsByChannelName()">
            Channel
            <i
              *ngIf="vm.sortTargetsByChannelNameAsc !== undefined"
              [ngClass]="{
                'icon-sort-asc': vm.sortTargetsByChannelNameAsc,
                'icon-sort-desc': !vm.sortTargetsByChannelNameAsc
              }"
            ></i>
          </th>
          <th>Name</th>
          <th>Type</th>
          <th>Target</th>
          <th class="sort-column" (click)="vm.sortTargetsByBitrate()">
            Bitrate
            <i
              *ngIf="vm.sortTargetsByBitrateAsc !== undefined"
              [ngClass]="{
                'icon-sort-asc': vm.sortTargetsByBitrateAsc,
                'icon-sort-desc': !vm.sortTargetsByBitrateAsc
              }"
            ></i>
          </th>
          <th>Uptime</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let target of vm.targets">
          <td>
            <label
              class="status"
              [ngClass]="{
                online: target.status === 'ONLINE',
                offline: target.status !== 'ONLINE'
              }"
              >{{ target.status }}</label
            >
          </td>
          <td>{{ target.availabilityZoneName }}</td>
          <td>{{ target.channelName }}</td>
          <td>{{ target.name }}</td>
          <td>{{ target.type }}</td>
          <td>{{ target.target }}</td>
          <td>{{ target.bitrate }}</td>
          <td>{{ target.uptime }}</td>
          <td>
            <span (click)="vm.showInputDetailsPopup(target)"
              >Show Bitrate Chart</span
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<evrideo-channel-input-details-popup
  *ngIf="vm && vm.inputChartPopupVM && vm.inputChartPopupVM.visible"
  [vm]="vm.inputChartPopupVM"
></evrideo-channel-input-details-popup>
